<template>
    <div class="pop-up btn-list">
      <div class="pop-header">
        <span class="pop-title">{{ popupTitle }}</span>
        <button class="btn-pop-close" @click="$.emit('close')">
          닫기<span class="overlay"></span>
        </button>
      </div>
      <div class="pop-btn-list">
        <button
          type="submit"
          class="btn-pop btn-submit"
          v-for="btn in btnList"
          :key="btn"
          @click="$.emit('setBtn', btn.idx)"
        >
          {{ btn.name }}<span class="overlay"></span>
        </button>
      </div>
    </div>
    <div class="dimed"></div>
</template>
<script>
export default {
  name: "popupBtnList",
  props: {
    popupTitle: String,
    btnList: Array,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>